var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.data.age)+" år, "+_vm._s(_vm.data.gender)+":")]),_c('div',{staticClass:"feedback"},[_vm._v(_vm._s(_vm.data.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }